//error
export const ErrorMessage = {
  ERROR_INFO: "Error obteniendo informaci\u00F3n",
  DEFAULT_ERROR: "Ha ocurrido un error inesperado",
  AUTHENTICATION_ERROR: "Usuario o contraseña incorrectos."
};
